import React from 'react';
import BuildIcon from '@material-ui/icons/Build';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { rebuildArtifactFile } from '../../../redux/actions/manageAssetActions';
import { artifactStatusMap } from '../../../Constants/Files';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
	textTransformNone: {
		textTransform: 'none',
	},
}));
// Rebuild source file Btn
const ArtifactRebuildBtn = ({ artifact }) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const handleClick = () => {
		dispatch(rebuildArtifactFile(artifact));
	};
	return (
		<div>
			<Button
				color="primary"
				size="large"
				disabled={artifact.status === artifactStatusMap.published.value || artifact.status === artifactStatusMap.live.value }
				onClick={handleClick}
				startIcon={<BuildIcon />}
				className={classes.textTransformNone}
			>
				Build
			</Button>
		</div>
	);
};

export default ArtifactRebuildBtn;
